module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0019.cb5cf641.jpg";